<template>
  <div>
    <legend>Долг - {{Reception}}</legend>
    <div class="text-right mb-5">
      <button @click="$router.go(-1)" class="btn btn-secondary ml-2" type="button">Назад</button>
    </div>
    <table class="table table-bordered table-hover table-sm">
      <tbody>
      <tr v-for="order in pointStats">
        <td>
          <router-link
            class="overflow-hidden text-nowrap d-inline-block"
            style="width: 200px; min-width: 100px; text-overflow: ellipsis;"
            target="_blank"
            :to="{ name: 'order-info', params: {orderId: order.Id}}">
            {{order.SferaNumber}} {{order.LocalNumber ? `/ ${order.LocalNumber}` : ''}}
          </router-link>
        </td>
        <td class="overflow-hidden text-nowrap"
            :title="order.Name"
            style="width: 1000px; max-width: 0; text-overflow: ellipsis;">{{order.Name}}
        </td>
        <td>{{order.Summary}}</td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { get } from '@/admin/services/api/http-utils';
import _ from 'lodash';

const url = `${process.env.VUE_APP_API_HOST}admin/debt`;

export default {
  data() {
    return {
      pointStats: [],
    };
  },
  computed: {
    Reception() {
      if (this.pointStats) {
        const f = _.first(this.pointStats)
        return f ? f.Reception : '';
      }
      return '';
    },
  },
  async mounted() {
    await this.fetchPointStats();
  },
  methods: {
    async fetchPointStats() {
      const { data } = await get(`${url}/point-stat-table/${this.$route.params.pointId}`);
      this.pointStats = data;
    },
  },
};
</script>
